import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { TenantsService } from '../../core/services/tenants.service';

export const customInterceptorInterceptor: HttpInterceptorFn = (req, next) => {
  const cookieService = inject(CookieService);
  const TenantsSer = inject(TenantsService);
  const tenantId = TenantsSer.getTenantFromSubdomain(); // Get the tenant ID from the service
  let clientapikey = '';
  switch (tenantId) {
    case 'NS':
      clientapikey = 'NS123'; // Set the client API key for NS tenant
      break;
    case 'TVL':
      clientapikey = 'TVL123'; // Set the client API key for NS tenant
      break;
    default:
      break;
  }
  const token = cookieService.get('authToken'); // use the injected service
  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
      'x-client-apikey': clientapikey,
    },
  });

  // Pass the modified request to the next handler
  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      console.error('HTTP error intercepted:', error);
      return throwError(() => error);
    })
  );
};
